<template>
  <div class="message-form" :class="{ 'collapsed': isCollapsed }">
    <div class="form-header" @click="toggleForm">
      <h3>Leave Your Messages to Relinex</h3>
      <button class="toggle-btn">
        <span v-if="isCollapsed">+</span>
        <span v-else>-</span>
      </button>
    </div>
    <form v-show="!isCollapsed" @submit.prevent="submitForm">
      <div class="form-group"><label for="name">Name</label><input type="text" id="name" v-model="formData.name" required /></div>
      <div class="form-group"><label for="email">Email</label><input type="email" id="email" v-model="formData.email" required /></div>
      <div class="form-group"><label for="phone">Phone</label><input type="tel" id="phone" v-model="formData.phone" required /></div>
      <div class="form-group"><label for="whatsapp">Whatsapp</label><input type="text" id="whatsapp" v-model="formData.whatsapp" required /></div>
      <div class="form-group"><label for="message">Message</label><textarea id="message" v-model="formData.message" required></textarea></div>
      <button type="submit" class="btn">Submit</button>
    </form>
    <!-- "Leave a message" text for the collapsed state -->
    <div class="collapsed-text" v-if="isCollapsed">Leave a Message</div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      isCollapsed: true, // Default to collapsed state
      formData: { name: '', email: '', phone: '', whatsapp: '', message: '' },
    };
  },
  methods: {
    toggleForm() {
      this.isCollapsed = !this.isCollapsed;
    },
    async submitForm() {
      try {
        this.isCollapsed = true;
        const response = await axios.post('https://relinexaesthetic.top:5000/send-email', this.formData, {
          headers: { 'Content-Type': 'application/json' },
        });
        this.formData = { name: '', email: '', phone: '', whatsapp: '', message: '' };
        // 跳转到感谢页面
        this.$router.push('/thank-you');
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    },
  },
};
</script>

<style scoped>
.message-form {
  position: fixed;
  bottom: 1px;
  right: 5px;
  width: 420px; /* Default width for larger screens */
  transition: width 0.3s ease, transform 0.3s ease;
  z-index: 99999999;
  background: #eaeaea;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.message-form.collapsed {
  width: 400px;
  height: 50px;
  transform: translateX(0); /* Keeps it in the right bottom corner */
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  color: #333;
  cursor: pointer;
}

h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #4a90e2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.toggle-btn {
  background: transparent;
  border: none;
  font-size: 20px;
  color: #4a90e2;
  cursor: pointer;
}

form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

form input, form textarea {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
}

form button {
  padding: 8px;
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

form button:hover {
  background-color: #357ab7;
}

/* Styling for the "Leave a Message" text in collapsed state */
.collapsed-text {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4a90e2;
  font-weight: 600;
  font-size: 16px;
  height: 100%;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .message-form {
    width: 100%; /* Make the form take full width on smaller screens */
    bottom: 0;
    right: 0;
    border-radius: 10px; /* Keep rounded corners */
  }

  .form-header {
    padding: 15px; /* More padding for easier tap target */
  }

  h3 {
    font-size: 14px; /* Slightly smaller title */
  }

  .toggle-btn {
    font-size: 18px; /* Adjust the button size for mobile */
  }

  form {
    padding: 15px; /* Increase padding for better touch experience */
  }

  form input, form textarea {
    font-size: 14px; /* Adjust input size */
  }

  form button {
    font-size: 14px; /* Button text size for mobile */
  }

  .collapsed-text {
    font-size: 14px; /* Adjust text size for smaller screens */
  }
}

@media (max-width: 480px) {
  .message-form {
    width: 100%; /* Full width on very small screens */
  }

  .form-header {
    padding: 20px; /* Extra padding for better accessibility */
  }

  .toggle-btn {
    font-size: 18px;
  }

  h3 {
    font-size: 12px; /* Make title even smaller on very small screens */
  }

  form button {
    font-size: 16px; /* Button text for smaller screens */
  }

  .collapsed-text {
    font-size: 12px; /* Further adjust text for smaller screens */
  }
}
</style>


// WEBPACK FOOTER //
// src/components/MessageForm.vue